export type ContentType =
  | 'topics'
  | 'outline'
  | 'blog'
  | 'social_posts'
  | 'linkedin_founder'
  | 'graphics_specs';

export type WeekStage =
  | 'topic_selection'
  | 'outline'
  | 'content_generation'
  | 'graphics'
  | 'ready'
  | 'published';

export type WeekStatus =
  | 'in_progress'
  | 'pending_approval'
  | 'needs_revision'
  | 'published';

export interface Week {
  id: string;
  status: WeekStatus;
  stage: WeekStage;
  topic: TopicProposal | null;
  created_by: string;
  created_at: { seconds: number } | null;
  updated_at: { seconds: number } | null;
  week_start: string | null;
}

export interface TopicProposal {
  title: string;
  slug: string;
  primary_keyword: string;
  secondary_keywords: string[];
  search_intent: 'informational' | 'commercial' | 'navigational';
  estimated_monthly_searches: number;
  difficulty: 'low' | 'medium' | 'high';
  why_now: string;
  compSignal_angle: string;
  word_count_target: number;
}

export interface ContentPiece {
  type: ContentType;
  content: string;
  status: 'pending_approval' | 'approved' | 'needs_revision';
  generated_at: { seconds: number } | null;
  topic?: TopicProposal;
}

export interface WorkflowState {
  activeWeekId: string | null;
  stage: WeekStage | null;
  updatedAt: { seconds: number } | null;
}

export interface AnalyticsSummary {
  total: number;
  published: number;
  inProgress: number;
  pendingApproval: number;
}

export const STAGE_LABELS: Record<WeekStage, string> = {
  topic_selection: 'Topic Selection',
  outline: 'Outline',
  content_generation: 'Content Generation',
  graphics: 'Graphics',
  ready: 'Ready to Publish',
  published: 'Published',
};

export const CONTENT_TYPE_LABELS: Record<ContentType, string> = {
  topics: 'Topic Proposals',
  outline: 'Content Outline',
  blog: 'Blog Post',
  social_posts: 'Social Posts',
  linkedin_founder: "Tarun's LinkedIn",
  graphics_specs: 'Graphics Specs',
};
